export enum ComponentIds {
  MegaNavigation = "mega-navigation",
  FiduciaryServices = "fiduciary-services",
  StatePlanFinder = "state-plan-finder",
  LowCost = "low-cost",
  EmployeeFees = "employee-fees",
  SecureApi = "secure-api",
  LiveSupport = "live-support",
  Banner = "banner",
}
